import { render, staticRenderFns } from "./shopCreateFeeAdd.vue?vue&type=template&id=75bbf518&scoped=true"
import script from "./shopCreateFeeAdd.vue?vue&type=script&lang=js"
export * from "./shopCreateFeeAdd.vue?vue&type=script&lang=js"
import style0 from "./shopCreateFeeAdd.vue?vue&type=style&index=0&id=75bbf518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bbf518",
  null
  
)

export default component.exports